import { render } from "./GiftWithdrawElement.vue?vue&type=template&id=0749fa64&scoped=true"
import script from "./GiftWithdrawElement.vue?vue&type=script&lang=js"
export * from "./GiftWithdrawElement.vue?vue&type=script&lang=js"

import "./GiftWithdrawElement.vue?vue&type=style&index=0&id=0749fa64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0749fa64"]])

export default __exports__